import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeviceCheckService {
  currentWidth = window.visualViewport.width;
  isLandscape = window.innerWidth > window.innerHeight;

  constructor() {
    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        if (screen.orientation.type.startsWith("landscape")) {
          this.currentWidth = Math.max(window.innerWidth, window.innerHeight);
          this.isLandscape = true;
        } else {
          this.currentWidth = Math.min(window.innerWidth, window.innerHeight);
          this.isLandscape = false;
        }
      });
    });
  }

  widthCheck(width: number) {
    return window.innerWidth < width;
  }

  onPC() {
    return this.currentWidth > 1200;
  }

  onTablet() {
    return !this.onPC();
  }

  onLandscape() {
    return this.isLandscape;
  }

  onPortrait() {
    return !this.onLandscape();
  }

  isTouch() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }
}
